
import React, { useState } from "react";
import EmojiPicker from "emoji-picker-react";
import closeIcon from "../../../../../../assets/icons/cross_sm_btn.png";
import pdficon from "../../../../../../assets/icons/pdficon.png";
import PlusIcon from '../../../../../../images/home-landing-page/plus-icon.png';
import TextIcon from '../../../../../../images/home-landing-page/text-icon.png';
import EmojiIcon from '../../../../../../images/home-landing-page/emoji-icon.png';
import MicIcon from '../../../../../../images/home-landing-page/mic-icon.png';
import SendIcon from '../../../../../../images/home-landing-page/send-icon.png';

const Index = ({ onSendMessage, filePreview, setFilePreview, setAttachmentUrl }) =>
{
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);
    // const [filePreview, setFilePreview] = useState(null); // For previewing the image
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    const handleFileChange = (e) =>
    {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith("image/"))
        {
            const previewUrl = URL.createObjectURL(selectedFile);
            setFilePreview(previewUrl); // Set image preview URL
            setAttachmentUrl(previewUrl); // Set URL for upload
        }
        // Check if the selected file is a PDF
        else if (selectedFile && selectedFile.type === "application/pdf")
        {
            // Set a placeholder or thumbnail for the PDF file
            const pdfThumbnail = pdficon; // Replace with actual thumbnail URL
            setFilePreview(pdfThumbnail); // Set the PDF thumbnail
            setAttachmentUrl(pdfThumbnail); // Set URL for upload (this could be a placeholder)
        } else
        {
            // Handle other file types (optional)
            setFilePreview(null);
            setAttachmentUrl(null);
        }
    };

    const handleSend = async () =>
    {
        let base64File = null;
        let fileName = null;

        if (file)
        {
            base64File = await convertFileToBase64(file);
            fileName = file.name;
        }

        onSendMessage(message, base64File, fileName);
        setMessage("");
        setFile(null); // Clear the file after sending
        setFilePreview(null); // Clear preview after sending
    };

    const handleKeyDown = (e) =>
    {
        if (e.key === "Enter")
        {
            handleSend();
        }
    };

    const handleEmojiClick = (emojiObject) =>
    {
        setMessage((prevMessage) => `${prevMessage}${emojiObject.emoji}`);
        setShowEmojiPicker(false);
    };

    const convertFileToBase64 = (file) =>
    {
        return new Promise((resolve, reject) =>
        {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleRemovePreview = () =>
    {
        setFile(null);
        setFilePreview(null);
        setAttachmentUrl(null);
    };

    return (
        <>
            {filePreview && (
                <div className="attachment-preview">
                    <figure>
                        <img
                            src={filePreview}
                            alt="Preview"
                        />
                    </figure>
                    <button
                        onClick={handleRemovePreview}
                        aria-label="Close preview"
                    >
                        <img src={closeIcon} onClick={handleRemovePreview} alt="Close" className="w-4 h-4 " />
                    </button>
                </div>
            )}
            <div className="send-message-mainbar">
                <div className="chat-attachment-button"
                    onClick={() => document.getElementById("fileInput").click()}>
                    <img src={PlusIcon} alt="Plus" />
                    <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />
                </div>
                <div className="chat-input-wrapper">
                    <input type="text" placeholder="Type a message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={handleKeyDown} />

                    <div class="send-chat-options">
                        <button type="button" onClick={() => setShowEmojiPicker((prev) => !prev)}>
                            <img src={EmojiIcon} alt="Smiley" />
                        </button>

                        <button type="button" className="send-button" onClick={handleSend}>
                            <img src={SendIcon} />
                        </button>
                    </div>
                    {showEmojiPicker && (
                        <div
                            style={{
                                position: "absolute",
                                bottom: "60px",
                                right: "50px",
                                zIndex: 1000,
                            }}
                        >
                            <EmojiPicker onEmojiClick={handleEmojiClick} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Index;

